import React from 'react';
import { ApplicationSettings } from '../../../models/settings';
import Button from '../../atoms/button/button';
import Link from 'next/link';
import { ButtonStyleType } from '../../../constants/button-style-type';

export type Props = {
  locale: string;
  appSettings: ApplicationSettings;
  homepageLinkText?: string;
};

export default function Page404({
  locale,
  appSettings,
  homepageLinkText = 'INTO Homepage',
}: Props) {
  return (
    <div className='container'>
      <div className='row'>
        <div className='col col-lg-7'>
          <h1>404 Page not found</h1>
          <div className='my-4'>
            Sorry, we were unable to find the page you are looking for. This might be because the
            page has moved, no longer exists or is temporarily unavailable.
          </div>
          <div className='mt-2'>
            <Button
              buttonURL={`/${locale}`}
              buttonRole='link'
              buttonStyle={ButtonStyleType.Filled}
              copyColor='#ffffff'
              backgroundColor={appSettings.branding.primaryColor}
              outlineColor={appSettings.branding.primaryColor}
              hoverBackgroundColor={appSettings.branding.primaryHoverColor}
              activeBackgroundColor={appSettings.branding.primaryActiveColor}
            >
              {homepageLinkText}
            </Button>
          </div>
          <h2 className='mt-4 mb-2'>Useful links</h2>
          <ul>
            <li>
              <Link href={`/${locale}/search`} target='_self'>
                Search programs
              </Link>
            </li>
            <li>
              <Link href={`/${locale}/universities`} target='_self'>
                Browse Universities
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
